import { connect } from 'react-redux';

import { FatInfrastructureList, IFatInfrastructureListProps } from '../../components/FatInfrastructureList';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';

export type TStoreProps = Pick<IFatInfrastructureListProps, 'list' | 'isHidden'>;
export type TDispatchProps = Pick<IFatInfrastructureListProps, 'onInit'>;

export function mapStateToProps(state: IState): TStoreProps {
  const { fatInfrastructureList } = state.villageData.village;

  return {
    list: fatInfrastructureList || [],
    isHidden: !state.isFatCard,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TDispatchProps {
  return {
    onInit: () => dispatch(setNavigationLink(NavigationLinkTypes.Features)),
  };
}

export const FatInfrastructureListContainer = connect<TStoreProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(FatInfrastructureList);
